import React, {Component} from "react";
import {WindowParamContext} from "../../library/context/WindowContext";
import {ColumnUnit} from "../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../library/basic/size";
import {ColumnAttr} from "../../library/basic/compose";
import {FontAttr} from "../../library/basic/font";
import {BoxUnit, heightGap} from "../../library/atomic/unit/BoxUnit";
import {ImageUnit} from "../../library/atomic/image/ImageUnit";
import {SpanText} from "../../library/atomic/text/SpanText";
import license from "../../assets/license/elec-business-license-compress.jpg";

export class BusinessLicensePage extends Component {
    static contextType = WindowParamContext;

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;
                    return (
                        <ColumnUnit fontAttr={new FontAttr(wp, "", "", "\"PingFang SC\"")}>
                            <ColumnUnit customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(),
                                {"minHeight": wp.currHeight + "px"})}>
                                {heightGap(wp, "72px")}
                                <SpanText
                                    fontAttr={new FontAttr(wp, "16px", "500")}
                                    customStyleAttr={ColumnAttr.getChildrenPositionObj()}>
                                    {"营业执照：91440400MAEC1E971N"}
                                </SpanText>
                                {heightGap(wp, "22px")}
                                <ImageUnit
                                    sizeAttr={new SizeAttr(wp, wp.currWidth > 1000 ? "680px" : (wp.currWidth * 0.68) + "px")}
                                    customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                                    url={license}/>
                                <BoxUnit customStyleAttr={{"minHeight": "84px", "marginBottom": "auto"}} />
                            </ColumnUnit>
                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}


